import * as React from 'react';
import { Radio } from '@highereducation/hen-ui';
import { fieldName } from '../submit';
import {
  FieldLegend,
  FieldErrorMessage,
  type FieldComponentProps,
} from './parts';

/**
 * RADIO field — hen-ui `Radio` group inside a fieldset/legend for grouping
 * semantics. `name`/`required` forward to the Radix root, which renders a hidden
 * native input so the selected value participates in `FormData` submission.
 */
export function RadioField({ field, formId, error }: FieldComponentProps) {
  const name = fieldName(formId, field.id);
  const choices = field.choices ?? [];

  return (
    <>
      <fieldset className='flex flex-col gap-xxs border-0 p-0'>
        <FieldLegend field={field} />
        <Radio
          name={name}
          required={Boolean(field.isRequired)}
          orientation='vertical'
          options={choices.map((choice) => ({
            value: choice.value,
            label: choice.text,
            error: Boolean(error),
          }))}
        />
      </fieldset>
      <FieldErrorMessage error={error} />
    </>
  );
}
